var $4b75d2bf0f24c30f$exports = {};
/**
 * DevThin Porsche Engineering Tools
 * Core Application Script & Interactive Simulators
 * UX Polish: ScrollSpy, Tactile Sliders, High-Contrast Chart Defaults
 */ document.addEventListener('DOMContentLoaded', ()=>{
    $4b75d2bf0f24c30f$var$initTheme();
    $4b75d2bf0f24c30f$var$initMobileNav();
    $4b75d2bf0f24c30f$var$highlightActiveNav();
    $4b75d2bf0f24c30f$var$initScrollSpy();
    $4b75d2bf0f24c30f$var$initImsTool();
    $4b75d2bf0f24c30f$var$initBoreTool();
});
/* --------------------------------------------------------------------------
   THEME MANAGER
   -------------------------------------------------------------------------- */ function $4b75d2bf0f24c30f$var$initTheme() {
    const themeToggle = document.getElementById('theme-toggle');
    if (!themeToggle) return;
    themeToggle.addEventListener('click', ()=>{
        const currentTheme = document.documentElement.getAttribute('data-theme') || 'dark';
        const nextTheme = currentTheme === 'dark' ? 'light' : 'dark';
        document.documentElement.setAttribute('data-theme', nextTheme);
        localStorage.setItem('dt-theme-mode', nextTheme);
    });
}
/* --------------------------------------------------------------------------
   MOBILE NAVIGATION
   -------------------------------------------------------------------------- */ function $4b75d2bf0f24c30f$var$initMobileNav() {
    const menuBtn = document.getElementById('mobile-menu-btn');
    const navMenu = document.getElementById('nav-menu');
    if (!menuBtn || !navMenu) return;
    menuBtn.addEventListener('click', ()=>{
        navMenu.classList.toggle('open');
    });
    // Close menu when a link is clicked
    navMenu.querySelectorAll('a').forEach((link)=>{
        link.addEventListener('click', ()=>{
            navMenu.classList.remove('open');
        });
    });
}
/* --------------------------------------------------------------------------
   ACTIVE NAV HIGHLIGHTER
   -------------------------------------------------------------------------- */ function $4b75d2bf0f24c30f$var$highlightActiveNav() {
    const path = window.location.pathname;
    document.querySelectorAll('.nav-link').forEach((link)=>{
        const href = link.getAttribute('href');
        if (path.endsWith(href) || href === 'index.html' && (path === '/' || path.endsWith('/'))) link.classList.add('active');
    });
}
/* --------------------------------------------------------------------------
   SCROLLSPY (Apple / Stripe Sticky Section Highlighter)
   -------------------------------------------------------------------------- */ function $4b75d2bf0f24c30f$var$initScrollSpy() {
    const subnavLinks = document.querySelectorAll('.subnav-link');
    if (!subnavLinks.length) return;
    const sections = [];
    subnavLinks.forEach((link)=>{
        const targetId = link.getAttribute('href');
        if (targetId && targetId.startsWith('#')) {
            const sectionEl = document.querySelector(targetId);
            if (sectionEl) sections.push({
                link: link,
                section: sectionEl
            });
        }
    });
    if (!sections.length) return;
    const observerOptions = {
        root: null,
        rootMargin: '-20% 0px -65% 0px',
        threshold: 0
    };
    const observer = new IntersectionObserver((entries)=>{
        entries.forEach((entry)=>{
            if (entry.isIntersecting) sections.forEach(({ link: link, section: section })=>{
                if (section === entry.target) link.classList.add('active-section');
                else link.classList.remove('active-section');
            });
        });
    }, observerOptions);
    sections.forEach(({ section: section })=>observer.observe(section));
}
/* --------------------------------------------------------------------------
   IMS BEARING TOOL CONTROLLER
   -------------------------------------------------------------------------- */ function $4b75d2bf0f24c30f$var$initImsTool() {
    const imsContainer = document.getElementById('ims-content');
    if (!imsContainer) return;
    // 1. Failure Rate Chart
    const ctx = document.getElementById('failureRateChart');
    if (ctx) new Chart(ctx.getContext('2d'), {
        type: 'bar',
        data: {
            labels: [
                'Gen 1 (Dual Row)',
                'Gen 2 (Single Row)',
                'Gen 3 (M97 Revision)'
            ],
            datasets: [
                {
                    label: 'Estimated Failure Rate (%)',
                    data: [
                        1,
                        9,
                        0.5
                    ],
                    backgroundColor: [
                        '#94a3b8',
                        '#f87171',
                        '#34d399' // Low risk - Bright Mint
                    ],
                    borderRadius: 8
                }
            ]
        },
        options: {
            responsive: true,
            maintainAspectRatio: false,
            plugins: {
                legend: {
                    display: false
                },
                tooltip: {
                    bodyFont: {
                        size: 14,
                        family: 'Inter'
                    },
                    titleFont: {
                        size: 14,
                        weight: 'bold',
                        family: 'Space Grotesk'
                    },
                    padding: 12,
                    callbacks: {
                        label: (context)=>` Estimated Failure Rate: ${context.parsed.y}%`
                    }
                }
            },
            scales: {
                y: {
                    beginAtZero: true,
                    max: 12,
                    ticks: {
                        font: {
                            size: 13,
                            family: 'JetBrains Mono'
                        },
                        color: '#94a3b8'
                    },
                    title: {
                        display: true,
                        text: 'Failure Percentage (%)',
                        font: {
                            size: 13,
                            weight: '600',
                            family: 'Inter'
                        },
                        color: '#cbd5e1'
                    },
                    grid: {
                        color: 'rgba(255, 255, 255, 0.08)'
                    }
                },
                x: {
                    ticks: {
                        font: {
                            size: 13,
                            weight: '600',
                            family: 'Inter'
                        },
                        color: '#e2e8f0'
                    },
                    grid: {
                        display: false
                    }
                }
            }
        }
    });
    // 2. Risk Identifier Dropdown
    const yearSelector = document.getElementById('year-selector');
    const resultCard = document.getElementById('result-card');
    const bearingName = document.getElementById('bearing-name');
    const riskLevel = document.getElementById('risk-level');
    const riskDesc = document.getElementById('risk-desc');
    const riskIcon = document.getElementById('risk-icon');
    const bearingData = {
        '1997': {
            name: 'Dual Row Deep Groove',
            risk: 'Low Risk (<1%)',
            statusClass: 'badge-status-low',
            boxClass: 'result-box-green',
            desc: 'Robust double-row design. While failures occur, they are statistically rare (<1%). The dual races tolerate significant wear and provide audible warning before disintegration.',
            icon: "\u2705"
        },
        '2000': {
            name: 'Transitional (Dual or Single Row)',
            risk: 'Moderate / Uncertain',
            statusClass: 'badge-status-moderate',
            boxClass: 'result-box-yellow',
            desc: 'VIN records are historically unreliable during this crossover. Engine may house a robust Dual Row or fragile Single Row bearing. Flange inspection required to verify.',
            icon: "\u26A0\uFE0F"
        },
        '2002': {
            name: 'Single Row (Industry 6204)',
            risk: "HIGH RISK (8%\u201310%)",
            statusClass: 'badge-status-danger',
            boxClass: 'result-box-red',
            desc: 'The weakest bearing design. Load capacity was effectively halved compared to Gen 1. Retrofit replacement with an IMS Solution or ceramic hybrid bearing is strongly advised.',
            icon: "\uD83D\uDED1"
        },
        '2005': {
            name: 'Split Production Year',
            risk: 'High (Boxster/Cayman) / Low (Late 911)',
            statusClass: 'badge-status-danger',
            boxClass: 'result-box-orange',
            desc: '911 models transitioned to the oversized bearing early, while 987.1 Boxsters and Caymans retained the fragile Single Row bearing well into 2006. Inspect the center nut diameter.',
            icon: "\uD83D\uDED1"
        },
        '2006': {
            name: 'M97 Revised Large Bearing',
            risk: 'Very Low Risk (<0.5%)',
            statusClass: 'badge-status-low',
            boxClass: 'result-box-green',
            desc: 'Porsche upsized the bearing diameter to 22mm, vastly increasing radial load capacity. Non-serviceable without splitting engine cases, but failures are statistically negligible.',
            icon: "\u2705"
        }
    };
    if (yearSelector && resultCard) yearSelector.addEventListener('change', (e)=>{
        const data = bearingData[e.target.value] || bearingData['1997'];
        bearingName.textContent = data.name;
        riskLevel.textContent = data.risk;
        riskDesc.textContent = data.desc;
        riskIcon.textContent = data.icon;
        riskLevel.className = `badge-status ${data.statusClass}`;
        resultCard.className = `result-box ${data.boxClass}`;
    });
    // 3. Kinematic Stepper Sequence
    const steps = [
        {
            id: 1,
            title: "Hydraulic Bleed Down",
            icon: "\uD83D\uDCA7",
            desc: "As hydraulic tensioners age, internal check valves leak and oil varnish prevents rapid pressurization during cold starts. The long timing chains develop dangerous slack."
        },
        {
            id: 2,
            title: "The Whip Effect",
            icon: "\u3030\uFE0F",
            desc: "Instead of rotating with smooth radial tension, the loose chain whips violently and slaps against composite wear pads, sending shockwaves through the shaft."
        },
        {
            id: 3,
            title: "Impact Shock Loading",
            icon: "\uD83D\uDD28",
            desc: "The ball bearing receives hammer-like impact loads exceeding its dynamic capacity. Ball surfaces spall, the ball cage shatters, and complete timing failure ensues."
        }
    ];
    const stepTitle = document.getElementById('step-title');
    const stepDesc = document.getElementById('step-desc');
    const stepVisual = document.getElementById('step-visual');
    function setImsStep(id) {
        const step = steps.find((s)=>s.id === id) || steps[0];
        if (stepTitle) stepTitle.textContent = step.title;
        if (stepDesc) stepDesc.textContent = step.desc;
        if (stepVisual) stepVisual.textContent = step.icon;
        document.querySelectorAll('.stepper-btn').forEach((btn)=>{
            const stepNum = parseInt(btn.getAttribute('data-step'));
            if (stepNum === id) btn.classList.add('active');
            else btn.classList.remove('active');
        });
    }
    document.querySelectorAll('.stepper-btn').forEach((btn)=>{
        btn.addEventListener('click', ()=>{
            const stepId = parseInt(btn.getAttribute('data-step'));
            setImsStep(stepId);
        });
    });
    // 4. Crankcase Chemistry Simulator
    const usageSlider = document.getElementById('usage-slider');
    const chemBox = document.getElementById('chem-box');
    const chemTitle = document.getElementById('chem-title');
    const chemDesc = document.getElementById('chem-desc');
    const chemIcon = document.getElementById('chem-icon');
    const freqLabel = document.getElementById('freq-label');
    if (usageSlider && chemBox) usageSlider.addEventListener('input', (e)=>{
        const val = parseInt(e.target.value);
        if (val < 30) {
            chemBox.className = "result-box result-box-red";
            chemTitle.textContent = "Acidic Corrosion & Pitting";
            chemDesc.textContent = "Moisture from combustion blow-by condenses in static oil to form sulfuric acid. Bearing balls sit submerged in an acid bath, causing pitting corrosion and false brinelling.";
            chemIcon.textContent = "\uD83E\uDDEA";
            freqLabel.textContent = "Garage Queen (<1k mi/yr)";
            freqLabel.className = "slider-active-val text-red";
        } else if (val < 70) {
            chemBox.className = "result-box result-box-yellow";
            chemTitle.textContent = "Moderate Condensation Risk";
            chemDesc.textContent = "Occasional short trips allow water to accumulate in the sump. Must be driven for >30 minutes continuously to heat oil past 212\xb0F and boil off moisture.";
            chemIcon.textContent = "\u26C5";
            freqLabel.textContent = "Weekend Toy";
            freqLabel.className = "slider-active-val text-amber";
        } else {
            chemBox.className = "result-box result-box-green";
            chemTitle.textContent = "Optimal Crankcase Chemistry";
            chemDesc.textContent = "Sustained oil temperature (>212\xb0F) actively evaporates moisture. Regular operation provides constant oil splash lubrication to flush the bearing cavity.";
            chemIcon.textContent = "\uD83D\uDD25";
            freqLabel.textContent = "Daily Driver";
            freqLabel.className = "slider-active-val text-green";
        }
    });
}
/* --------------------------------------------------------------------------
   BORE SCORING TOOL CONTROLLER
   -------------------------------------------------------------------------- */ function $4b75d2bf0f24c30f$var$initBoreTool() {
    const boreContainer = document.getElementById('bore-content');
    if (!boreContainer) return;
    // 1. Thermal Dynamics Simulator
    const tempSlider = document.getElementById('temp-slider');
    const piston = document.getElementById('piston');
    const oilLayer = document.getElementById('oil-layer');
    const tempVal = document.getElementById('temp-val');
    const clearanceDisplay = document.getElementById('clearance-display');
    const statusDisplay = document.getElementById('status-display');
    const cylinderSize = 250;
    const basePistonSize = 210;
    if (tempSlider && piston && oilLayer) tempSlider.addEventListener('input', (e)=>{
        const val = parseInt(e.target.value);
        let tempText = "Cold Start (Ambient)";
        let colorClass = "text-blue";
        if (val > 30 && val <= 70) {
            tempText = "Operating Temperature";
            colorClass = "text-green";
        } else if (val > 70 && val <= 90) {
            tempText = "High Load / Rapid Expansion";
            colorClass = "text-amber";
        } else if (val > 90) {
            tempText = "CRITICAL THERMAL SHOCK";
            colorClass = "text-red";
        }
        tempVal.textContent = tempText;
        tempVal.className = `slider-active-val ${colorClass}`;
        // Piston Expansion Calculation
        const expansionFactor = val / 100 * (cylinderSize - basePistonSize + 4);
        const newSize = basePistonSize + expansionFactor;
        piston.style.width = `${newSize}px`;
        piston.style.height = `${newSize}px`;
        // Oil Film Opacity
        const maxGap = (cylinderSize - basePistonSize) / 2;
        const currentGap = (cylinderSize - newSize) / 2;
        const oilOpacity = Math.max(0, currentGap / maxGap);
        oilLayer.style.width = `${newSize + 8}px`;
        oilLayer.style.height = `${newSize + 8}px`;
        oilLayer.style.backgroundColor = `rgba(234, 179, 8, ${oilOpacity})`;
        // Status
        if (val > 92) {
            piston.style.background = "linear-gradient(145deg, #ef4444, #991b1b)";
            statusDisplay.textContent = "SEIZURE / FLASH MELT (1070\xb0F)";
            statusDisplay.className = "metric-val text-red animate-pulse";
            clearanceDisplay.textContent = "ZERO (Interference Fit)";
            clearanceDisplay.className = "metric-val text-red";
        } else if (val > 75) {
            piston.style.background = "linear-gradient(145deg, #f59e0b, #b45309)";
            statusDisplay.textContent = "Oil Film Shearing / Boundary State";
            statusDisplay.className = "metric-val text-amber";
            clearanceDisplay.textContent = "Critical (<10 microns)";
            clearanceDisplay.className = "metric-val text-amber";
        } else {
            piston.style.background = "linear-gradient(145deg, #cbd5e1, #94a3b8)";
            statusDisplay.textContent = "Hydrodynamic Film Intact";
            statusDisplay.className = "metric-val text-green";
            clearanceDisplay.textContent = "Healthy (25\u201335 microns)";
            clearanceDisplay.className = "metric-val text-green";
        }
    });
    // 2. Failure Mechanism Toggle
    const contentArea = document.getElementById('mechanism-content');
    const btnSeizure = document.getElementById('btn-seizure');
    const btnScoring = document.getElementById('btn-scoring');
    const mechanismData = {
        seizure: {
            title: "Full Thermal Adhesive Seizure (MA1 / Alusil)",
            icon: "\uD83D\uDED1",
            desc: "Occurs when differential thermal expansion and casting shrinkage reduce piston-to-bore clearance to absolute zero.",
            points: [
                "<strong>Thermodynamic Shock:</strong> Piston heats instantly under heavy throttle before the water-cooled aluminum block can expand.",
                "<strong>Oil Film Displacement:</strong> Mechanical interference squeezes out the lubricating film, entering dry metal boundary sliding.",
                "<strong>Eutectic Flash Melt:</strong> Friction elevates local temperatures past 1070\xb0F (576\xb0C), micro-welding piston alloy to cylinder Alusil.",
                "<strong>Bilateral Scoring:</strong> Forensic hallmark is damage on BOTH thrust and anti-thrust skirt faces."
            ]
        },
        scoring: {
            title: "Abrasive Bore Scoring (Gen 1 M96 / Lokasil)",
            icon: "\uD83D\uDD2A",
            desc: "A progressive cutting failure mode driven by detached silicon particles trapped against the piston skirt.",
            points: [
                "<strong>Silicon Fiber Delamination:</strong> Hard silicon fibers (Hardness >1000 Vickers) detach from the Lokasil preform matrix.",
                "<strong>Particle Embedment:</strong> The detached grit embeds into softer polymer/plastic piston skirt coatings.",
                "<strong>Lathe Cutting Action:</strong> The embedded particle acts like a machine cutting tool, gouging vertical channels into the cylinder wall.",
                "<strong>Unilateral Asymmetry:</strong> Concentrated almost exclusively on Bank 2 Thrust Side where combustion forces press the piston."
            ]
        }
    };
    function showMechanism(type) {
        if (!contentArea || !btnSeizure || !btnScoring) return;
        const data = mechanismData[type];
        if (type === 'seizure') {
            btnSeizure.classList.add('active');
            btnScoring.classList.remove('active');
        } else {
            btnScoring.classList.add('active');
            btnSeizure.classList.remove('active');
        }
        contentArea.innerHTML = `
      <div class="mech-header">
        <span class="mech-icon">${data.icon}</span>
        <h4 class="mech-title">${data.title}</h4>
      </div>
      <p class="mech-desc">${data.desc}</p>
      <ul class="mech-points-list">
        ${data.points.map((p)=>`<li class="mech-point-item">${p}</li>`).join('')}
      </ul>
    `;
    }
    if (btnSeizure && btnScoring) {
        btnSeizure.addEventListener('click', ()=>showMechanism('seizure'));
        btnScoring.addEventListener('click', ()=>showMechanism('scoring'));
        showMechanism('seizure');
    }
    // 3. Oil Film Chart
    const ctxOil = document.getElementById('oilFilmChart');
    if (ctxOil) new Chart(ctxOil.getContext('2d'), {
        type: 'line',
        data: {
            labels: [
                'Idle (700 RPM)',
                'Low RPM (1.5k)',
                "Peak Torque (2.5k\u20134k)",
                'High RPM (6.5k+)'
            ],
            datasets: [
                {
                    label: 'Oil Film Thickness (microns)',
                    data: [
                        85,
                        70,
                        20,
                        50
                    ],
                    borderColor: '#fbbf24',
                    backgroundColor: 'rgba(251, 191, 36, 0.18)',
                    fill: true,
                    tension: 0.4,
                    pointRadius: 5,
                    pointBackgroundColor: '#fbbf24'
                }
            ]
        },
        options: {
            responsive: true,
            maintainAspectRatio: false,
            plugins: {
                legend: {
                    display: false
                },
                tooltip: {
                    bodyFont: {
                        size: 14,
                        family: 'Inter'
                    },
                    titleFont: {
                        size: 14,
                        weight: 'bold',
                        family: 'Space Grotesk'
                    },
                    padding: 12,
                    callbacks: {
                        label: (ctx)=>` Relative Oil Film Strength: ${ctx.parsed.y}%`
                    }
                }
            },
            scales: {
                y: {
                    display: true,
                    ticks: {
                        font: {
                            size: 12,
                            family: 'JetBrains Mono'
                        },
                        color: '#94a3b8'
                    },
                    title: {
                        display: true,
                        text: 'Film Thickness',
                        font: {
                            size: 13,
                            weight: '600'
                        },
                        color: '#cbd5e1'
                    },
                    grid: {
                        color: 'rgba(255, 255, 255, 0.08)'
                    }
                },
                x: {
                    ticks: {
                        font: {
                            size: 13,
                            weight: '600',
                            family: 'Inter'
                        },
                        color: '#e2e8f0'
                    },
                    grid: {
                        display: false
                    }
                }
            }
        }
    });
    // 4. Comparison Chart
    const ctxComp = document.getElementById('comparisonChart');
    if (ctxComp) new Chart(ctxComp.getContext('2d'), {
        type: 'bar',
        data: {
            labels: [
                'Silicon Bonding',
                'Material Hardness',
                'Failure Frequency'
            ],
            datasets: [
                {
                    label: 'Gen 1 (Lokasil)',
                    data: [
                        40,
                        60,
                        80
                    ],
                    backgroundColor: '#94a3b8',
                    borderRadius: 6
                },
                {
                    label: 'Gen 2 (Alusil)',
                    data: [
                        85,
                        70,
                        30
                    ],
                    backgroundColor: '#60a5fa',
                    borderRadius: 6
                }
            ]
        },
        options: {
            responsive: true,
            maintainAspectRatio: false,
            plugins: {
                legend: {
                    labels: {
                        boxWidth: 14,
                        font: {
                            size: 13,
                            family: 'Inter',
                            weight: '600'
                        },
                        color: '#e2e8f0'
                    }
                },
                tooltip: {
                    bodyFont: {
                        size: 14,
                        family: 'Inter'
                    },
                    titleFont: {
                        size: 14,
                        weight: 'bold',
                        family: 'Space Grotesk'
                    },
                    padding: 12
                }
            },
            scales: {
                y: {
                    beginAtZero: true,
                    max: 100,
                    ticks: {
                        font: {
                            size: 12,
                            family: 'JetBrains Mono'
                        },
                        color: '#94a3b8'
                    },
                    grid: {
                        color: 'rgba(255, 255, 255, 0.08)'
                    }
                },
                x: {
                    ticks: {
                        font: {
                            size: 13,
                            weight: '600',
                            family: 'Inter'
                        },
                        color: '#e2e8f0'
                    },
                    grid: {
                        display: false
                    }
                }
            }
        }
    });
    // 5. Risk Calculator
    const warmupInput = document.getElementById('warmup-input');
    const styleInput = document.getElementById('style-input');
    const warmupVal = document.getElementById('warmup-val');
    const riskBar = document.getElementById('risk-bar');
    const riskText = document.getElementById('risk-text');
    const riskAdvice = document.getElementById('risk-advice');
    function calculateRisk() {
        if (!warmupInput || !styleInput || !riskBar || !riskText || !riskAdvice) return;
        const time = parseInt(warmupInput.value);
        const style = parseInt(styleInput.value);
        warmupVal.textContent = `${time} min`;
        let risk = 0;
        if (style === 1) risk += 10;
        if (style === 2) risk += 20;
        if (style === 3) risk += 65; // Mid-range torque danger zone
        if (style === 4) risk += 55; // High RPM throttle
        let mitigation = time / 30;
        if (mitigation > 1) mitigation = 1.2;
        let finalRisk = risk - risk * mitigation * 0.85;
        finalRisk += 10; // baseline casting risk
        if (finalRisk < 5) finalRisk = 5;
        if (finalRisk > 100) finalRisk = 100;
        riskBar.style.width = `${finalRisk}%`;
        if (finalRisk < 30) {
            riskBar.className = "gauge-bar-fill gauge-fill-green";
            riskText.textContent = "Low Risk";
            riskText.className = "gauge-status-text text-green";
            riskAdvice.textContent = "Optimal operational profile. Engine block aluminum has expanded to maintain required piston-to-bore clearances.";
        } else if (finalRisk < 65) {
            riskBar.className = "gauge-bar-fill gauge-fill-yellow";
            riskText.textContent = "Moderate Risk";
            riskText.className = "gauge-status-text text-amber";
            riskAdvice.textContent = "Caution: Allow the aluminum engine block at least 20\u201330 minutes to expand before applying heavy mid-range throttle.";
        } else {
            riskBar.className = "gauge-bar-fill gauge-fill-red";
            riskText.textContent = "CRITICAL COLD SEIZURE RISK";
            riskText.className = "gauge-status-text text-red animate-pulse";
            riskAdvice.textContent = "DANGER: High torque loads on a cold block collapse clearance and shear the hydrodynamic oil film, inducing adhesive flash melting.";
        }
    }
    if (warmupInput && styleInput) {
        warmupInput.addEventListener('input', calculateRisk);
        styleInput.addEventListener('change', calculateRisk);
        calculateRisk();
    }
}


export {$4b75d2bf0f24c30f$exports as default};
//# sourceMappingURL=bore-scoring.ba5b10fa.js.map
